// General category options for Activities and Price Items
export const GENERAL_CATEGORY_OPTIONS = [
    'Bathing',
    'Care',
    'Checks',
    'Cognitive',
    'Dressing',
    'Fluid intake',
    'General',
    'Housekeeping',
    'Hygiene',
    'Medication',
    'Mobility',
    'Nursing',
    'Nutrition',
    'Social',
    'Toileting'
];